import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M17.273 2.815a.75.75 0 0 1 .912-.542 5.64 5.64 0 0 1 3.46 2.596.75.75 0 1 1-1.29.762 4.14 4.14 0 0 0-2.54-1.904.75.75 0 0 1-.542-.912" />
    <path
      fillRule="evenodd"
      d="m14.53 6.283-1.446-2.504-.002-.004a2.625 2.625 0 0 0-4.5-.048A2.625 2.625 0 0 0 4.54 6.981l.314.544a2.625 2.625 0 0 0-2.063 3.93l3.563 6.17a8.25 8.25 0 1 0 14.29-8.251l-1.687-2.923-.003-.004a2.625 2.625 0 0 0-4.424-.164m-3.425-2.268a1.125 1.125 0 0 0-1.266 1.643l.006.01 2.43 4.209a.75.75 0 0 1-1.3.75L7.789 5.106a1.126 1.126 0 0 0-1.95 1.125l1.5 2.597.015.026L9.4 12.4a.75.75 0 1 1-1.299.75L6.04 9.58a1.126 1.126 0 0 0-1.95 1.125l3.563 6.171a6.751 6.751 0 0 0 11.693-6.751L17.66 7.205v-.002a1.125 1.125 0 0 0-1.95 1.125l.937 1.622a.75.75 0 0 1-.274 1.024 3 3 0 0 0-1.099 4.098.75.75 0 1 1-1.299.75 4.5 4.5 0 0 1 1.03-5.717l-.59-1.022-.005-.007-2.623-4.545a1.13 1.13 0 0 0-.682-.516"
      clipRule="evenodd"
    />
    <path d="M5.15 18.375a.75.75 0 0 0-1.3.75c.71 1.23 1.555 2.324 2.68 3.213a.75.75 0 0 0 .93-1.177c-.936-.74-1.665-1.669-2.31-2.786" />
  </>
);

const HandWaving = Icon('hand-waving', svgContents);

export default HandWaving;
